import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { Ability } from '@casl/ability';

const ability = new Ability([]);

export const AbilityContext = createContext(ability);

export const Can = createContextualCan(AbilityContext.Consumer);
